export default "__VITE_ASSET__e127f0b3__"